export enum MetadataRightType {
  publication = "publication",
  production = "production",
  rightCompany = "rightCompany"
}
